
<div class="map-container">

  <app-loader [style.visibility]="isLoading ? 'visible' : 'hidden'" diameter="100" class="loader"/>

  <div class="map-frame">
    <div id="map"></div>
  </div>

  <div
    class="carousel"
  >
    <app-events-map-carousel
      [eventsArray]="eventsGeoJSON.features"
      [selectedEvent]="selectedEvent"
    />
  </div>

</div>
